import { exactValidator, genericValidateName, uuidValidator } from './genericName';
import * as libHabitat from './habitat';
import * as libInvestor from './investor';
export const prefix = 'investorPolicySupportedIssuedInstruments';
export const nameToID = (name) => {
    validateName(name);
    const parts = name.split('/');
    return {
        habitatID: parts[1],
        investorID: parts[3],
        issuedInstrumentID: parts[5],
    };
};
export const validateName = genericValidateName([
    exactValidator(libHabitat.prefix),
    uuidValidator(),
    exactValidator(libInvestor.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
